module.exports = __webpack_public_path__ + "static/media/viettel.9922236e.svg";